import { Component, Input } from '@angular/core';
import { NopInput } from '../../../models';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-nop-input',
    standalone: true,
    imports: [],
    template: ` <div class="col-12 p-0"></div> `
})
export class NopInputComponent extends BaseInputComponent {
    @Input() name!: string;
    @Input() override control!: NopInput;
}
